interface DomainVerdict {
  domain: string;
  status: string;
  note: string;
}

interface Props {
  domains: DomainVerdict[];
  labels: Record<string, string>;
  selected?: string;
  onSelect?: (domain: string) => void;
  title: string;
}

function dotColor(status: string): string {
  if (status === 'green') return 'var(--green)';
  if (status === 'flag') return 'var(--yellow)';
  if (status === 'critical') return 'var(--red)';
  return 'var(--gray)';
}

export default function DomainBoard({ domains, labels, selected, onSelect, title }: Props) {
  const byDomain = new Map(domains.map((d) => [d.domain, d]));
  const ids = Object.keys(labels);

  return (
    <div className="section">
      <h3>{title}</h3>
      <style>{`
        .domain-grid { display: grid; grid-template-columns: repeat(4, 1fr); gap: 8px; }
        @media (max-width: 700px) { .domain-grid { grid-template-columns: repeat(3, 1fr); } }
        @media (max-width: 480px) { .domain-grid { grid-template-columns: repeat(2, 1fr); } }
      `}</style>
      <div className="domain-grid">
        {ids.map((id) => {
          const verdict = byDomain.get(id);
          const status = verdict?.status ?? 'not-assessed';
          const note = verdict?.note ?? 'not yet assessed';
          const isSelected = selected === id;
          return (
            <div
              key={id}
              onClick={onSelect ? () => onSelect(isSelected ? '' : id) : undefined}
              className="card"
              style={{
                display: 'block',
                margin: 0,
                cursor: onSelect ? 'pointer' : 'default',
                borderColor: isSelected ? 'var(--accent)' : undefined,
              }}
            >
              <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 4 }}>
                <span
                  style={{
                    display: 'inline-block',
                    width: 8,
                    height: 8,
                    borderRadius: '50%',
                    background: dotColor(status),
                    flexShrink: 0,
                  }}
                />
                <span className="card-title" style={{ fontSize: 12.5 }}>{labels[id]}</span>
              </div>
              <div className="card-sub" style={{ whiteSpace: 'normal' }}>{note}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
